<template>
  <div class="Scale_classification">
      <div class="group-content">
        <details
          v-for="sub in talkFormData"
          :key="sub.name"
          class="sub-box"
        >
          <summary class="sub-summary">
            {{ sub.name }}
          </summary>

          <!-- 表格内容 -->
          <table class="content-table">
            <thead>
              <tr>
                <th>内容</th>
                <th>选项</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, idx) in sub.items"
                :key="idx"
                class="table-row"
              >
                <td>{{ item.content }}</td>
                <td>
                  <p
                    v-for="opt in item.options"
                    :key="opt"
                    class="option-label"
                  >
                    <input type="checkbox" :value="opt" />{{ opt }}
                  </p>
                </td>
                <td>
                  <input
                    type="text"
                    class="notes-input"
                    :placeholder="item.notes"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </details>
      </div>
  </div>
</template>

<script setup>
const talkFormData = [
      {
        name: "经历类",
        items: [
          { content: "沟通交流情况", options: ["正常沟通", "不善言辞", "拒绝沟通"], notes: "" },
          { content: "年龄", options: ["高龄（60周岁以上）", "未成年（18周岁以下）"], notes: "" },
          { content: "残疾人员", options: ["是", "否"], notes: "" },
          { content: "少数名族（特指有名族习俗的）", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "涉稳关注人员（含上访）", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "同性恋", options: ["是", "否"], notes: "" },
          { content: "涉毒人员", options: ["是", "否"], notes: "" },
          { content: "涉艾人员", options: ["是", "否"], notes: "" },
          { content: "疑似精神异常", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "特殊身份", options: ["人大代表", "企事业负责人","审前未羁押人员","涉 XJ","在领域内一定影响力的人员（如网红）","其他"], notes: "勾选后三项，需备注" },
          { content: "多次羁押史（三次及以上）", options: ["有", "无"], notes: "" },
          { content: "羁押史中有严重违规经历", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "有过激抗捕行为", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "其他", options: ["有", "无【托底标签，可手动填写】"], notes: "勾选有，需备注" }
        ]
      },
      {
        name: "案件类",
        items: [
          { content: "“八大类“案件", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "督办案件", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "案件产生或可能产生较大社会影响", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "承认罪名/犯罪事实", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "罪名变更等情形的", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "具有从轻情节的", options: ["有自首情节的", "有坦白/检举情节的","其他"], notes: "勾选其他需备注" },
          { content: "环节变动（含法院判决）后情绪波动较大", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "提审/会见后情绪波动较大", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "其他", options: ["有", "无【托底标签，可手动填写】"], notes: "勾选有，需备注" },
        ]
      },
      {
        name: "思想类",
        items: [
          { content: "心理测评异常", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "性格偏执，情绪波动较大", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "存在不满情绪，扬言报复等极端言行", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "家庭情况", options: ["直系亲属重病/离世", "高龄（重病）父母/未成年子女无人照料","婚恋关系难以维系","其他情况"], notes: "勾选其他，需备注" },
          { content: "其他情况", options: ["（系负责人）公司濒临破产", "因案件羁押遭单位解雇","因羁押无法处理相关重要事项（如房产公证等）","其他情形"], notes: "勾选其他，需备注" }
        ]
      },
      {
        name: "秩序类",
        items: [
          { content: "重大一级风险人员日常表现情况", options: ["正常", "不正常"], notes: "勾选不正常，需备注" },
          { content: "重大二级风险人员日常表现情况", options: ["正常", "不正常"], notes: "勾选不正常，需备注" },
          { content: "严重扰乱监管秩序", options: ["是", "否"], notes: "" },
          { content: "存在”牢头狱霸“行为", options: ["是", "否"], notes: "" },
          { content: "不服监管", options: ["软对抗行为（如小病大养）", "教唆他人不服监管","经教育批评，屡教不改","故意制造狱内矛盾"], notes: "勾选首个，需备注" },
          { content: "有暴力行为或劣迹", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "有暴动行为或劣迹", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "有自伤自残行为或劣迹", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "故意损毁监内设施设备", options: ["有", "无"], notes: "" },
          { content: "存在辱骂他人（未动手）", options: ["有", "无"], notes: "" },
          { content: "自制、私藏严重影响监室安全违禁品", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "其他", options: ["有", "无【托底标签，可手动填写】"], notes: "勾选有，需备注" }
        ]
      },
      {
        name: "疾病类",
        items: [
          { content: "重大三级风险人员日常表现情况", options: ["正常", "不正常"], notes: "勾选不正常，需备注" },
          { content: "基础疾病", options: ["正常", "一般、可控", "存在列为重大三级风险情形的"], notes: "勾选选项三，需备注" },
          { content: "严重疾病术后收押的", options: ["是，生活自理", "是，生活无法自理","否"], notes: "勾选选项二，需备注" },
          { content: "残疾人员", options: ["是，生活自理", "是，生活无法自理","否"], notes: "勾选选项二，需备注" },
          { content: "需要服专属药物（如精神类）", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "过敏史", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "传染病史", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "遗传病史", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "其他", options: ["有", "无【托底标签，可手动填写】"], notes: "勾选有，需备注" }
        ]
      },
      {
        name: "权益类",
        items: [
          { content: "三无人员", options: ["是", "否"], notes: "" },
          { content: "有宗教信仰", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "入所前有伤情（不含陈旧伤）", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "入所后新增严重疾病", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "入所后新增严重伤情", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "入所后专项体检异常", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "有检举、申诉、控告、举报等情形", options: ["检举", "申诉", "控告", "举报"], notes: "勾选任一项，需备注" },
          { content: "需要法律援助", options: ["有", "无"], notes: "" },
          { content: "出所后有特殊情况需要对接的", options: ["有", "无"], notes: "勾选有，需备注" },
          { content: "是否受到逼供诱供", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "办案机关是否强迫签字认罪", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "监内是否受到欺负或者其他不公正待遇", options: ["是", "否"], notes: "勾选是，需备注" },
          { content: "其他", options: ["有", "无【托底标签，可手动填写】"], notes: "勾选有，需备注" },
        ]
      }
]
</script>

<style scoped>
.Scale_classification {
  padding: 16px;
  background-color: #f9fafc;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  height: 96%;;
}

/* 一级分类内容容器 */
.group-content {
  padding: 12px 16px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

/* 二级分类外框 */
.sub-box {
  border: 1px solid #dce3ea;
  border-radius: 6px;
  margin-top: 16px;
  overflow: hidden;
  transition: box-shadow 0.3s;
  background-color: #ffffff;
}

.sub-box:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

/* 二级分类标题 */
.sub-summary {
  background-color: #eef2f7;
  padding: 10px 14px;
  font-weight: 600;
  font-size: 15px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s;
}

.sub-summary:hover {
  background-color: #e2e8f0;
}

/* 表格整体样式 */
.content-table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
  font-size: 14px;
  color: #444;
}

/* 表头样式 */
.content-table thead {
  background-color: #f1f5f9;
  color: #555;
}

.content-table th,
.content-table td {
  border: 1px solid #e5e7eb;
  padding: 10px;
  text-align: left;
}

/* 表格行 hover 效果 */
.table-row:hover {
  background-color: #f9fbfc;
}

/* 选项 label 样式 */
.option-label {
  display: inline-block;
  margin-right: 12px;
  color: #333;
}

.option-label input[type="checkbox"] {
  margin-right: 4px;
}

/* 备注文本输入框 */
.notes-input {
  border: 1px solid #cbd5e1;
  padding: 6px 10px;
  border-radius: 4px;
  width: 100%;
  font-size: 14px;
  transition: border-color 0.2s;
  width: auto;
}

.notes-input:focus {
  outline: none;
  border-color: #3b82f6;
}
</style>